<template>
  <qx-card title="列表">
    <section slot="titleRight">
      <qx-permpisions permpisions>
        <ExportBtn
          :len="tableData.data.length"
          queryUrl="reportActionBO.ajax?cmd=orgDateReport"
          :params="fullSearchData"
          bizName="部门运营日报表"
          :excelKeys="excelKeys"
          :excelLables="excelLables"
          type="sync"
        />
      </qx-permpisions>
    </section>
    <section class="tablePage">
      <!-- 表格 -->
      <section class="tableBox" ref="tableBox">
        <el-table v-loading="tableData.loading" :data="tableData.data" :height="tableHeight">
          <!-- 常规列表项 -->
          <el-table-column
            v-for="(item, index, key) in tableData.title"
            :key="key"
            :prop="item.prop"
            :label="item.label"
            :sortable="item.sortable"
            :filters="item.filters"
            :filter-method="item.filterHandler"
            :min-width="item.width || 150"
            :width="item.w"
            :fixed="item.fixed"
            align="center"
          >
            <template v-if="item.children">
              <el-table-column
                v-for="(childItem, childIndex) in item.children"
                :key="childIndex"
                :prop="childItem.prop"
                :label="childItem.label"
                :min-width="childItem.width || 120"
                :width="childItem.w"
              />
            </template>
            <section slot-scope="scope">
              <section v-if="scope.column.property === 'customerCode'" @click="toDetail(scope.row)">
                <span class="primary cur">
                  {{
                  scope.row[scope.column.property]
                  }}
                </span>
              </section>
              <section
                v-if="scope.column.property !== 'customerCode'"
              >{{ scope.row[scope.column.property] }}</section>
            </section>
          </el-table-column>
          <!-- 常规列表项 end -->
        </el-table>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.page"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.rows"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
  </qx-card>
</template>

<script>
import tableMixin from '@qx/mixin/table';
import ExportBtn from 'components/exportBtn';
import {
  orgDateReport,
} from 'api/report';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
    ExportBtn,
  },
  data () {
    return {
      tableData: { // 表格相关数据
        loading: false,
        rows: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          {
            prop: 'feeTime',
            label: '日期',
            fixed: 'left',
            width: 100,
          },
          {
            prop: 'orderNum',
            label: '开单数量',
            width: 80,
          },
          {
            label: '应靠台车辆信息',
            children: [
              {
                prop: 'shouldOrder',
                label: '应靠台数量',
                width: 80,
              },
              {
                prop: 'zcar',
                label: '自有车',
                width: 80,
              },
              {
                prop: 'wcar',
                label: '外调车',
                width: 80,
              },
              {
                prop: 'zhcar',
                label: '招商车',
                width: 80,
              },
              {
                prop: 'gcar',
                label: '挂靠车',
                width: 80,
              },
            ],
          },
          {
            prop: 'toNum',
            label: '应到达数量',
            width: 80,
          },
          {
            prop: 'lateNum',
            label: '晚靠台数量',
            width: 80,
          },
          {
            prop: 'ofToNum',
            label: '迟到数量',
            width: 80,
          },
          {
            prop: 'abnormalNum',
            label: '异常数量',
            width: 80,
          },
          {
            prop: 'abnormalFee',
            label: '异常金额',
          },
          {
            prop: 'limitationNum',
            label: '时效罚款数量',
            width: 80,
          },
          {
            prop: 'limitationFee',
            label: '时效罚款金额',
          },

          {
            label: '当天应靠台订单信息',
            children: [
              {
                prop: 'shouldOrderToda',
                label: '当天应靠台订单',
              },
              {
                prop: 'estimateFee',
                label: '订单预估收入',
              },
              {
                prop: 'oilFee',
                label: '油费',
              },
              {
                prop: 'tollFee',
                label: '过路费',
              },
              {
                prop: 'freightFee',
                label: '运费（现金）',
              },
            ],
          },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: orgDateReport,
  },
};
</script>

<style lang="scss" scoped>
</style>
